
{
      "BASE_URL": "http://adminapi.shiftclockai.com:80/",
     "APPLICATION_BASEURL":"http://adminapi.shiftclockai.com:80/"
}